import axios from '@/plugin/axios';

// get requests
export const getOrganization = (page = 1, pagesize = 1000) =>
  axios.get(`./organizations/?page=${page}&size=${pagesize}`);
export const getAnOrganization = (id) => axios.get(`./organizations/${id}`);
export const getOrganizationProject = (id) => axios.get(`./projects/?organization=${id}`);
